// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"535cd70d","787":"644f7641","880":"f1f39859"}[chunkId] + ".chunk.js";
};